export default __webpack_public_path__ + "static/media/withdrawal.ae108179.svg";